import { useState } from 'react'
import { MuiChipsInput } from 'components/ChipsInput'

export interface SelectPropertySpyListFromLocationProps {
    onLocationListChange: (value: string[]) => void
}

export const SelectPropertySpyListFromLocation = (props: SelectPropertySpyListFromLocationProps): JSX.Element => {
    const {
        onLocationListChange
    } = props

    const [locationList, setLocationList] = useState<string[] | undefined>([])

    const handleLocationChange = (event: any) => {
        setLocationList(event)
        onLocationListChange?.(event)
    }

    return (
        <div>
            <MuiChipsInput
                clearInputOnBlur={true}
                value={locationList}
                name={'locations'}
                label="Locations *"
                onChange={handleLocationChange}
            />
        </div>
    )
}